const TABS_CONTAINER = '[data-tabs]'
const TABS_CONTROL = '[data-tab-control]'
const TABS_CONTENT = '[data-tab-content]'

const tabsPlugin = document.querySelectorAll(TABS_CONTAINER).forEach((tabsContainer) => {
    tabsContainer.querySelectorAll(TABS_CONTROL).forEach((tabControl) => {
        tabControl.addEventListener('click', (event) => {

            const target =  event.currentTarget;

            tabsContainer.querySelectorAll(TABS_CONTROL).forEach((tabControl) => {
                if(tabControl === target){
                    tabControl.classList.add('-active-tab-control')
                }else {
                    tabControl.classList.remove('-active-tab-control')
                }
            });
            tabsContainer.querySelectorAll(TABS_CONTENT).forEach((tabContent) => {

                if(tabContent.dataset.tabContent === target.dataset.tabControl){
                    tabContent.classList.add('-active-tab-content')
                }else {
                    tabContent.classList.remove('-active-tab-content')
                }
            });


        })
    })
})